@import "./sellalong-panel.css";

:host {
  clear: both;
  margin-top: 80px;
  padding: 140px 0 80px;
  position: relative;
  top: -80px;
}

.sellalong-panel-footer .sellalong-panel-footer__checkout-buttons > input {
  min-width: 200px;
}

.sellalong-panel-login-start-cta {
  background-color: var(--sellalong-colour-primary, #000);
  border-radius: 3px;
  color: #fff;
  padding: 15px 25px;
  font-size: 15px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border: none;
}

.sellalong-panel-login .Form__Row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.sellalong-panel-login .Form__Column {
  margin-right: 10px;
}

.sellalong-panel-login .Form__Column:last-child {
  margin-right: 0;
}
